import { useStateContainer } from '@state-containers/react';
import { BlockCreatorState } from '../state/BlockCreatorState';

export const useBlockCreator = () => {
  return useStateContainer(BlockCreatorState);
};

export type BlockCreator = ReturnType<typeof useBlockCreator>;
